import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';

import Clearfix from 'Common/Clearfix/Clearfix.jsx';
import IconCard from 'Common/Cards/IconCard';
import FormGroup from 'Components/FormGroup';
import Workflow from './containers/Workflow';
import Comments from './containers/Comments';
import Attachments from './containers/Attachments';
import SubmissionExternalList from './containers/SubmissionExternalList';
import ReviewersAssignmentList from './containers/ReviewersAssignmentList';
import ReviewRounds from './components/ReviewRounds';
import { aclDecorator } from 'Decorators';
import {
    ROLE_AUTHOR,
    ROLE_EDITOR,
    ROLE_EDITORIAL,
    ROLE_ADMIN,
    PHASE_AUTHOR_DECISION,
    PHASE_PEER_REVIEW,
    ROLE_EDITORIAL_BOARD,
    TYPE_BOARD_MEMBER,
    STATUS_ACCEPTED, ROLE_CHIEF_EDITORIAL, PHASE_DECISION_MAKING, PHASE_PUBLISHED,
} from 'Constants';
import AuthorsInfoList from 'Layouts/SubmissionManagement/components/AuthorsInfoList';

const styles = theme => ({
    field: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
    },
});

@aclDecorator()
class SubmissionCard extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        isPhase: PropTypes.func.isRequired,
        isOneOfPhases: PropTypes.func.isRequired,
        isStatus: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
        submissionData: PropTypes.object.isRequired,
        phasesList: PropTypes.array.isRequired,
        isOneOf: PropTypes.func.isRequired,
        is: PropTypes.func.isRequired,
        onFileUpload: PropTypes.func.isRequired,
    };

    state = {
        template: {},
        templateAdditional: null,
        showAssignReviewers: false,
        isReviewFinished: false
    };

    getExternalRound() {
        const {
            submissionData: { reviewers },
            user: { id },
        } = this.props;

        const reviewer = reviewers ?
            reviewers.find(reviewer => reviewer.type === TYPE_BOARD_MEMBER && reviewer.user_id === id && reviewer.status === STATUS_ACCEPTED) :
            null;

        return reviewer ? reviewer.submission_review_round_id : null;
    }

    /**
     * Author info
     * NOT FOR reviewers
     * @returns {*}
     */
    getAuthorInfo() {
        const { submissionData, isOneOf, is } = this.props;
        const authorLink = is(ROLE_ADMIN) ? `/users/${submissionData.user_id}` : is(ROLE_AUTHOR) ? '/profile' : '#';

        return isOneOf([ROLE_AUTHOR, ROLE_ADMIN, ROLE_EDITORIAL, ROLE_EDITOR, ROLE_CHIEF_EDITORIAL]) ? (
            <FormGroup title="field.manuscript_authors_readonly.label">
                <div className="info-wrapper-text">
                    <a className="author-and-co-author-link" href={authorLink}>
                        {submissionData.profiles[0].first_name} {submissionData.profiles[0].last_name}
                    </a>
                    {submissionData.profiles
                        .map(profile => {
                            return profile.user_id === submissionData.user_id
                                ? ''
                                : profile.first_name + ' ' + profile.last_name;
                        })
                        .join(', ')}
                </div>
            </FormGroup>
        ) : null;
    }

    /**
     * Comments block
     * NOT FOR reviewers
     * @returns {*}
     */
    getCommentsBlock() {
        const { submissionData, isOneOf } = this.props;

        return (
            isOneOf([ROLE_AUTHOR, ROLE_ADMIN, ROLE_EDITORIAL, ROLE_EDITOR, ROLE_CHIEF_EDITORIAL]) && (
                <FormGroup title="field.manuscript_comments.label">
                    <div className="info-wrapper-comments">
                        <Comments submissionId={submissionData.id} />
                    </div>
                </FormGroup>
            )
        );
    }

    getContent() {
        const {
            isPhase,
            isOneOfPhases,
            isStatus,
            submissionData,
            submissionData: { rounds },
            phasesList,
            isOneOf,
            is,
            onFileUpload
        } = this.props;
        const { showAssignReviewers, isReviewFinished } = this.state;
        const journalTitle = submissionData.journal ? submissionData.journal.title : '';
        const roundId = is(ROLE_EDITORIAL_BOARD) && isPhase(PHASE_PEER_REVIEW) ? this.getExternalRound() : null;

        return (
            <div>
                <FormGroup title="field.manuscript_title_readonly.label">
                    <div className="info-wrapper-text">{submissionData.title}</div>
                </FormGroup>

                {this.getAuthorInfo()}

                {isOneOf([ROLE_AUTHOR, ROLE_ADMIN, ROLE_EDITORIAL, ROLE_EDITOR, ROLE_CHIEF_EDITORIAL]) &&
                    <AuthorsInfoList profiles={submissionData.profiles}/>}

                <FormGroup title="field.journal_id_readonly.label">
                    <div className="info-wrapper-text">
                        {is(ROLE_ADMIN) ? <a className="author-and-co-author-link" href={`/journals/${submissionData.journal_id}`}>
                            { journalTitle }
                        </a> : journalTitle }
                    </div>
                </FormGroup>
                <FormGroup title="field.abstract_readonly.label">
                    <div className="info-wrapper-text">{submissionData.extract}</div>
                </FormGroup>

                <Attachments submissionData={submissionData} onFileUpload={onFileUpload} />

                {isOneOf([ROLE_ADMIN, ROLE_EDITORIAL, ROLE_EDITOR, ROLE_CHIEF_EDITORIAL]) &&
                    isOneOfPhases([PHASE_PEER_REVIEW, PHASE_DECISION_MAKING, PHASE_AUTHOR_DECISION, PHASE_PUBLISHED]) &&
                    rounds.length && <ReviewRounds submission={submissionData} rounds={rounds} />}

                {isOneOf([ROLE_ADMIN, ROLE_EDITORIAL, ROLE_EDITOR, ROLE_CHIEF_EDITORIAL]) &&
                    (isPhase(PHASE_AUTHOR_DECISION) || submissionData.author_decision !== null) && (
                        <FormGroup title="field.manuscript_author_decision_readonly.label">
                            <div className="info-wrapper-text">
                                <FormattedMessage
                                    id={
                                        submissionData.author_decision
                                            ? 'submission.decision.agreed'
                                            : submissionData.author_decision === null
                                                ? 'submission.decision.wait'
                                                : 'submission.decision.declined'
                                    }
                                />
                            </div>
                        </FormGroup>
                    )
                }

                {this.getCommentsBlock()}

                {roundId &&
                    <SubmissionExternalList
                        roundId={roundId}
                        submission={submissionData}
                        isReviewFinished={isReviewFinished}
                    />
                }

                <Workflow
                    isPhase={isPhase}
                    isStatus={isStatus}
                    submission={submissionData}
                    phasesList={phasesList}
                    toggleAssignReviewers={(template, templateAdditional = null) =>
                        this.setState({
                            showAssignReviewers: !showAssignReviewers,
                            template,
                            templateAdditional,
                        })
                    }
                    roundId={this.getExternalRound()}
                    isReviewFinished={isReviewFinished}
                    finishReview={this.finishReview}
                />
            </div>
        );
    }

    finishReview = () =>
        this.setState({isReviewFinished: true});

    render() {
        const { submissionData } = this.props;
        const { showAssignReviewers, template, templateAdditional } = this.state;

        if (!submissionData || !submissionData.profiles) {
            return null;
        }

        return (
            <IconCard
                title={<FormattedMessage id={'form_groups.general'} />}
                backButton={{
                    to: '/',
                    title: 'button.to.submissions',
                }}
                content={
                    <div className="submission-general-block submission-page-card">
                        {showAssignReviewers ? (
                            <ReviewersAssignmentList
                                journalId={submissionData.journal_id}
                                submissionId={submissionData.id}
                                template={template}
                                templateHandle={templateAdditional}
                                toggleAssignReviewers={() =>
                                    this.setState({ showAssignReviewers: !showAssignReviewers })
                                }
                                profiles={submissionData.profiles}
                            />
                        ) : (
                            this.getContent()
                        )}
                        <Clearfix />
                    </div>
                }
            />
        );
    }
}

export default withStyles(styles)(SubmissionCard);



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/SubmissionCard.jsx